<template>
  <div>



      <div class="col-md-12 sp-form-container mb-5">

          <div class="card col-md-12">

              <div class="card-body">

                  <div class="row m-2">
                      <div class="col-md-4"></div>
                      <div class="col-md-4 text-center center-block">
                          <img class="" :src="image" alt="画像">
                      </div>
                      <div class="col-md-4"></div>
                  </div>

                  <div class="row text-center m-2">
                      <h3 class="col-md-12">
                        <span v-if="legal_person==1">{{ cinit(corp_name, '-') }}</span>
                        <span v-else-if="legal_person==0">{{ cinit(store_name, '-') }}</span>
                        <span v-if="identification_flg==0" class="jump_identification not_identification_font">本人確認未提出</span> 
                        <span v-if="identification_flg==1" class="jump_identification not_identification_font">本人確認審査中</span> 
                        <span v-if="identification_flg==2" class="jump_identification not_identification_font">本人確認審査NG</span> 
                        <span v-if="identification_flg==3" class="identification_font">本人確認済</span> 
                      </h3>
                  </div>

                  <div class="col-md-12 text-center p-0 m-0 mb-4">
                      <div class="center-block cc h5 mt-2 d-flex">
                        <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="evaluation"></star-rating>
                      </div>
                  </div>

                  <div class="row text-center m-2 my-5">
                      <div class="col-md-4"></div>
                      <a class="btn btn-default col-md-4" style="color: #82ce76;border: dashed 1px;" href="javascript:void(0);" @click="jampSeller">販売者ページを入力</a>
                      <div class="col-md-4"></div>
                  </div>

                  <div class="row m-2 mt-3 mb-3 text-center">

                  <div class="card col-md-4 pl-0 pr-0 m-0" style="border-left: solid 1px #d7d7d7;">
                      <div class="card-header p-1" style="background: linear-gradient(to bottom, #f9f9f9 0%, #ececec 100%);">
                          <p class="card-text">商品申込数</p>
                      </div>
                      <div class="card-body p-1">
                          <p class="text-center card-text">{{ productCount }} 回</p>
                      </div>
                  </div>

                  <div class="card col-md-4 pl-0 pr-0 m-0" style="border-left: solid 1px #d7d7d7;">
                      <div class="card-header p-1" style="background: linear-gradient(to bottom, #f9f9f9 0%, #ececec 100%);">
                          <p class="card-text">試弾申込数</p>
                      </div>
                      <div class="card-body p-1">
                          <p class="text-center card-text">{{ testBulletCount }} 回</p>
                      </div>
                  </div>

                  <div class="card col-md-4 pl-0 pr-0 m-0" style="border-left: solid 1px #d7d7d7;">
                      <div class="card-header p-1" style="background: linear-gradient(to bottom, #f9f9f9 0%, #ececec 100%);">
                          <p class="card-text">お気に入り登録数</p>
                      </div>
                      <div class="card-body p-1">
                          <p class="text-center card-text">{{ favoriteCount }} 回</p>
                      </div>
                  </div>

                  </div>

              </div>
              <!--<div class="card-footer">フッタ</div>-->
          </div>

      </div>

      <h5>お知らせ</h5>
      <hr>

      <div class="py-3 contents">
        <p>コメント未返信 {{ not_replay_comment }}件 <a v-if="not_replay_comment>0" class="ml-3 btn btn-info" href="javascript:void(0);" @click="jumpComment">確認する</a></p>
        <p>メッセージ未返信 {{ not_replay_message }}件 <a v-if="not_replay_message>0" class="ml-3 btn btn-info" href="javascript:void(0);" @click="jumpMessage">確認する</a></p>
      <div>

  </div>
</template>

<script>
import StarRating from 'vue-star-rating'

export default {
  components: {
    'star-rating': StarRating,
  },
  props: { 
    user: Object
  },
  data() {
    return {
      not_replay_message: 0,
      not_replay_comment: 0,
      image: null,
      legal_person: null,
      corp_name: null,
      store_name: null,
      identification_flg: null,
      evaluation: 0,
      productCount: 0,
      testBulletCount: 0,
      favoriteCount: 0,
    }
  },
	methods: {
	  jumpMessage: function(){
      // location.href = '/mypage?page=6';
      this.$router.push({path: '/mypage', query: {page: 6}});
	  },
    jumpComment: function(){
      // location.href = '/mypage?page=5';
      this.$router.push({path: '/mypage', query: {page: 7}});
	  },
    jampSeller: function(){
      // location.href = '/mypage?page=3&anc=f3';
      this.$router.push({path: '/mypage', query: {page: 3, anc: 'f3'}});
	  },
	  async get_dashboard() {
		  this.$store.dispatch('user/get_dashboard', {}).then(res => {
		    let ret = res.data;
		    console.log(ret);
		    this.not_replay_message = ret['not_replay_message'];
        this.not_replay_comment = ret['not_replay_comment'];
		    this.image = ret['image'];
		    this.legal_person = ret['legal_person'];
		    this.corp_name = ret['corp_name'];
		    this.store_name = ret['store_name'];
		    this.identification_flg = ret['identification_flg'];
		    this.productCount = ret['productCount'];
		    this.testBulletCount = ret['testBulletCount'];
		    this.favoriteCount = ret['favoriteCount'];
		    this.evaluation = ret['evaluation'];
		  }, error => {
		    console.log('error発生');
		    console.log(error);
		    this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
		    });
  	  });
	  },
  },
  created() {
    this.get_dashboard();
  }
}
</script>

<style>
.vue-star-rating {
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mypage/seller/main.vue